import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

function Error404(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
      <h1>404 - Page not found</h1>
      <div id="error404">
        <p>Sorry, we could not find the page you were looking for.</p>
        <Link to="/">Go to the home page</Link>
      </div>
      <div class="bottom-space"><br /></div>
    </main>
  )
}

export default Error404